function ExpandOnFirstPage() {
	return (
		<div className="expand-on-first-page" id="second-page">
			<div className="home-flex-container">
				<div className="one-line">A little more about our courses:</div>
				<div className="three-points">
					<div className="heading-three-points">
						{`> Separate courses, shared projects`}
					</div>
					<div className="explanation-three-points">
						<p>
							We are running two courses side-by-side, a web development course,
							and a design course.
						</p>
						<p>
							👾 The web development course will teach you how to code, web
							fundamentals, frameworks, and dev skills to land a job, and take
							your career anywhere you want to go.
						</p>
						<p>
							👾 The design course will teach you the fundamentals of research,
							design, prototyping and testing so that you can take your UX
							career in any direction.
						</p>
						<p>
							We will bring in senior developers and product managers to help
							being real world experience to the projects that you do. No job in
							tech is done solo in a basement these days - it's about
							collaboration and helping one another, and this course aims to
							bring this to the fore because these are the skills that are
							sought after in industry.
						</p>
					</div>
					<div className="heading-three-points">
						{`> We teach the fundamentals to let you then take charge in your career`}
					</div>
					<div className="explanation-three-points">
						<p>
							In both courses the emphasis is on problem solving, and building a solid foundation. We want you to learn the basics to a high level so that you can be the guide to your career. 
						</p>
						<p>
							Both courses offer real world experience, and career oriented skills so that you hit the ground running in that first job - but the strength of the course will be building that grounding so that you can leave the course ready to learn anything that will take you where you want to go in tech.
						</p>
					</div>
					<div className="heading-three-points">
						{`> We are in the industry`}
					</div>
					<div className="explanation-three-points">
						<p>
							💻 Everyone here works in tech and has done for years. We have
							connections to industry. We know the skills that will get you the
							best start. We aren't interested in buzzwords and 'selling'. The
							courses are hard, but they will give you the best entry into the
							field.
						</p>

						<p>
							💻 Furthermore, we care deeply about teaching. We have all had
							stints at teachers, and all think long and hard about how to do
							this better. We structure the course to have things flow from
							theory to challenges to projects to real-world examples of
							projects.{" "}
						</p>

						<p>
							💻 The people in our orbit will be able to come through and speak
							to you about their experiences in tech, give different
							perspectives, and different ideas about pathways in this world.
						</p>

						<p>
							💻 We want you to bring your experince to the course. If you just
							want a fresh start in tech, we can provide that for you. But if
							you want tech to enhance your current career - to leverage the
							skills that you have now - then we want to help you.{" "}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ExpandOnFirstPage;
